import { useTranslation } from 'react-i18next';
import { formatCurrency } from '~/utils';

export function OrderSummaryCard({ totalAmount }: { totalAmount: number }) {
  const { t } = useTranslation('order');

  return (
    <div className="bg-neut-light rounded-lg border border-gray-200 p-6 shadow-sm">
      <h2 className="text-neutral-900 font-semibold mb-4">
        {t('order.order_summary')}
      </h2>
      <div className="space-y-3">
        <div className="flex items-center justify-between text-sm">
          <span className="text-gray-600">{t('order.item_total')}</span>
          <span className="text-neutral-900 font-medium">
            {formatCurrency(totalAmount)}
          </span>
        </div>
        <div className="flex items-center justify-between text-sm">
          <span className="text-gray-600">{t('order.shipping_fee')}</span>
          <span className="text-neutral-900 font-medium">TBD</span>
        </div>
        <div className="border-t border-gray-200 pt-3 flex items-center justify-between">
          <span className="text-neutral-900 font-semibold">
            {t('order.total_amount')}
          </span>
          <span className="text-xl text-neutral-900 font-semibold">
            {formatCurrency(totalAmount)}
          </span>
        </div>
      </div>
    </div>
  );
}
